import React from "react";

export const LeftArrow = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 17"
    >
      <path d="M11.963 3.975a.7.7 0 01.213.525.7.7 0 01-.213.525L8.21 9l3.754 3.975c.284.3.284.75 0 1.05-.283.3-.708.3-.991 0l-4.25-4.5a.755.755 0 010-1.05l4.25-4.5c.283-.3.708-.3.991 0z" />
    </svg>
  );
};
